import { render, staticRenderFns } from "./noRecordComponent.vue?vue&type=template&id=67b636e0&scoped=true&"
import script from "./noRecordComponent.vue?vue&type=script&lang=js&"
export * from "./noRecordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b636e0",
  null
  
)

export default component.exports